<template>
<v-card>
  <v-card-title class='subtitle-1 overline' touchless >
    Add a new member to your team
  </v-card-title>
  <v-window v-model="active" vertical >
    <v-window-item >
      <v-card flat>
        <v-card-title class='subtitle-1 overline' >
        </v-card-title>
        <v-card-text >
          <v-text-field outline class='ag-input-xl' label='Email address' type='email' />
          <v-text-field label='Phone' type='phone' />
          <v-text-field label='registration number' />
          <v-radio-group row >
            <v-radio label='member' />
            <v-radio label='owner' />
          </v-radio-group>
        </v-card-text>
      </v-card>
    </v-window-item >
  </v-window>
  <v-card-actions >
    <v-spacer/>
    <v-btn @click='next' color='primary' >
      Next
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  name: 'AddMember',
  data () {
    return {
      active: 0
    }
  },
  methods: {
    next () {
      this.active++
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?67d19062